var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.modelValue,"title":"打赏记录","width":"1002px"},on:{"close":_vm.onClose}},[_c('boxcoin-records',{attrs:{"postType":_vm.postType,"postId":_vm.postId,"postClient":_vm.client,"mode":"normal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }